import {
  GET_SAVS,
  GET_SAVS_COMPLETED,
  GET_SAVS_FAILED,
  GET_SAV,
  GET_SAV_COMPLETED,
  GET_SAV_FAILED,
  GET_SAV_CONSTANTS_COMPLETED,
  GET_SAV_EN_COURS_COMPLETED,
} from "./actions";

const initialState = {
  savs: [],
  isLoading: false,
  isInitialized: false,
  constants: null,
  currentSav: {
    data: null,
    isLoading: false,
  },
  enCours: {
    count: 0,
    savs: [],
  },
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_SAVS:
      return { ...state, isLoading: true };
    case GET_SAVS_COMPLETED:
      return {
        ...state,
        savs: action.payload.result.savs || [],
        isLoading: false,
        isInitialized: true,
      };
    case GET_SAVS_FAILED:
      return { ...state, isLoading: false, isInitialized: true };

    case GET_SAV:
      return { ...state, currentSav: { ...state.currentSav, isLoading: true } };
    case GET_SAV_COMPLETED:
      return {
        ...state,
        currentSav: { data: action.payload.result.sav, isLoading: false },
      };
    case GET_SAV_FAILED:
      return { ...state, currentSav: { data: null, isLoading: false } };

    case GET_SAV_CONSTANTS_COMPLETED:
      return { ...state, constants: action.payload.result };

    case GET_SAV_EN_COURS_COMPLETED:
      return {
        ...state,
        enCours: {
          count: action.payload.result.count || 0,
          savs: action.payload.result.savs || [],
        },
      };

    default:
      return state;
  }
};

export default reducers;
